import * as React from 'react';
import { useBOMStore } from 'src/hooks/bom';
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const BomDeletePopup = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const { data, SetStatus } = props;
    const [{ }, { fetch_bom_project_detail_with_bom}, { delete_bom_by_bom_id }] = useBOMStore();
    const onHide = () => {
        SetStatus(false)
    };
    const [{ }, {system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const loader = __check('BOM_OPERATION_API_CALL').status;

    const onDeleteBom = async () => {
        let bomId = data && data.single_bom && data.single_bom.bomId
        await delete_bom_by_bom_id({ bomId });
        onHide()
        await fetch_bom_project_detail_with_bom()
        system_alert_indicator({
            name: 'deleteBom',
            message: 'Your BOM <b>' + `${data && data.single_bom && data.single_bom.bomName}` + '</b> has been deleted',
            type: "success"
        })
    };

    return (
        <>
            <div className="avnet-modal modal-550 ">
                <div className="avnet-modal-inner">
                    <button type="button" className="close py-3" data-dismiss="modal" disabled={loader}
                        onClick={onHide}>×
                    </button>
                    <div className="modal-header border-0">
                        
                    </div>

                    <div className='moda-body pt-0'>
                        <h3 className="modal-title text-center m-auto mb-5">Are you sure you want to delete this BOM?</h3>
                    </div>

                    <div className="modal-footer d-flex justify-content-center">
                        <button type="button" className="bs5 btn btn-secondary w145"
                            disabled={loader}
                            onClick={onHide}>cancel
                        </button>
                        <button type="button" className="bs5 btn btn-primary w145" disabled={loader}
                            onClick={onDeleteBom}>
                            {loader ? <i className="fa fa-spinner fa-spin" /> : "delete bom"}
                        </button>

                    </div>
                </div>
            </div>
        </>
    )
}

export default BomDeletePopup;